import { t } from "@/i18n-js/instance";
import { canManageSpace } from "@/react/helpers/spaceHelpers";
import { usePunditUserContext } from "@circle-react/contexts";
import type { Event } from "@circle-react/types";
import { Typography } from "@circle-react-uikit/Typography";
import { Basic } from "./Basic";
import { DateAndTime } from "./DateAndTime";
import { Location } from "./Location";
import { Ticket } from "./Ticket";
import { useLiveValuesWatch } from "./hooks/useLiveValuesWatch";

interface BasicInfoProps {
  event: Event;
  setLocationType: (locationType: string) => void;
}

export const BasicInfo = ({ event, setLocationType }: BasicInfoProps) => {
  const { space } = useLiveValuesWatch(event);
  const { currentCommunityMember } = usePunditUserContext();
  const { is_admin: isAdmin } = currentCommunityMember || {};
  const isPaidEventCreationAllowed = isAdmin;

  return (
    <>
      {event && (
        <Typography.TitleXl>
          {t("events.create.form.basic_info")}
        </Typography.TitleXl>
      )}

      <Basic
        event={event}
        canCreateTopics={space ? canManageSpace(space) : false}
        requireTopicSelection={space?.require_topic_selection}
      />
      <DateAndTime event={event} />
      <Location event={event} setLocationType={setLocationType} />
      {isPaidEventCreationAllowed && <Ticket event={event} />}
    </>
  );
};
